(() => {
  const REDUCED =
    window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const INIT = "__scRotInit";

  function parseTerms(raw) {
    return String(raw || "")
      .split("|")
      .map(s => s.trim())
      .filter(Boolean);
  }

  function initOne(input) {
    if (!input || input[INIT]) return;
    input[INIT] = true;

    const wrap = input.closest(".t4s-search-header__main");
    if (!wrap) return;

    const termEl = wrap.querySelector(".sc-rot-term");
    if (!termEl) return;

    const terms = parseTerms(termEl.getAttribute("data-rot-terms"));
    if (!terms.length) return;

    let idx = 0;
    let timer = null;

    const hasText = () => (input.value || "").trim().length > 0;
    const isFocused = () => document.activeElement === input;

    const updateState = () => {
      wrap.classList.toggle("is-focused", isFocused());
      wrap.classList.toggle("is-typing", hasText());
    };

    const stop = () => {
      if (timer) clearTimeout(timer);
      timer = null;
    };

    const cycle = () => {
      stop();

      if (REDUCED) return;
      if (document.hidden) return;
      if (isFocused() || hasText()) return;

      // Zepto-ish timing:
      // 1) visible for a bit
      timer = setTimeout(() => {
        if (isFocused() || hasText()) return;

        // 2) fade OUT
        termEl.classList.add("is-out");

        // 3) swap at end of fade
        timer = setTimeout(() => {
          if (isFocused() || hasText()) return;

          idx = (idx + 1) % terms.length;
          termEl.textContent = `"${terms[idx]}"`;

          // 4) fade IN
          termEl.classList.remove("is-out");

          // 5) schedule next cycle
          cycle();
        }, 220);
      }, 1600);
    };

    // init text
    termEl.textContent = `"${terms[0]}"`;
    idx = 0;

    // listeners
    input.addEventListener("focus", () => { updateState(); stop(); });
    input.addEventListener("blur",  () => { updateState(); cycle(); });
    input.addEventListener("input", () => { updateState(); if (hasText()) stop(); else cycle(); });

    document.addEventListener("visibilitychange", () => {
      if (document.hidden) stop();
      else cycle();
    });

    updateState();
    cycle();

    // cleanup if removed
    const mo = new MutationObserver(() => {
      if (!document.contains(input)) {
        stop();
        mo.disconnect();
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  function initAll(root = document) {
    root.querySelectorAll("input.js-rotating-search").forEach(initOne);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAll());
  } else {
    initAll();
  }

  // In case theme dynamically re-renders header
  document.addEventListener("shopify:section:load", (e) => initAll(e.target));
})();
